<template>
	<div class="container-fluid mt-4">
		<div class="text-center mb-5" v-if="!userStore.isViewingUser()">
			<router-link class="btn bprimary m-2" to="/add"
				>Add Meal/Drink</router-link
			>
			<!-- <router-link
				class="btn btn-lg btn-orange m-2"
				to="/food-checker"
				v-if="isOnline"
				>Food Checker</router-link
			> -->
		</div>
		<birthday :user="userStore.user" />
		<ul class="nav nav-tabs nav-fill mb-2">
			<li class="nav-item">
				<a
					class="nav-link"
					href="#"
					:class="{ active: page === 1 }"
					@click="page = 1"
					>Quick Info</a
				>
			</li>
			<li class="nav-item">
				<a
					class="nav-link"
					href="#"
					:class="{ active: page === 2 }"
					@click="page = 2"
					>Track</a
				>
			</li>
			<li class="nav-item">
				<a
					class="nav-link"
					href="#"
					:class="{ active: page === 3 }"
					@click="page = 3"
					>Reports</a
				>
			</li>
			<li class="nav-item">
				<a
					class="nav-link"
					href="#"
					:class="{ active: page === 4 }"
					@click="page = 4"
					>Fun</a
				>
			</li>
		</ul>
		<div :key="userStore.uuid">
			<template v-if="page === 1">
				<glass-card
					v-if="iqStore.item_queue.length > 0"
					class="mb-5 processing-section p-5">
					<h2>Processing Items:</h2>
					<div class="d-flex flex-row flex-wrap gap-3">
						<processing :item="q" v-for="q in iqStore.item_queue" :key="q.id" />
					</div>
				</glass-card>
				<div>
					<nutritional-banner />
				</div>
				<div class="quick-info-container">
					<!-- <div
						class="quick-info-item"
						v-if="
							!Capacitor.isNativePlatform() &&
							SubscriptionHelper.isFreeAccount()
						"> -->
					<!-- <hilltop-ad
							script-src="//chavamephu.com/b.XCVpsVdnGfl/0_YMWIcL/oe/mG9PuoZSUTlTkRP/THYOyrMjz/MWxUO/DYQltUNLjwI/zzM-z/E_4FNaQG"
							:settings="{ key: 'zone1-banner' }" /> -->
					<!-- <adsterra-ad hash="dc5f70d9412313edb3e0ab902fb3efa5" /> -->
					<!-- <advertise-product-here v-if="!Capacitor.isNativePlatform()" /> -->
					<!-- <amazon-ad />
					</div> -->
					<div class="quick-info-item">
						<todays-foods />
					</div>
					<div class="quick-info-item">
						<daily-meal-plan />
					</div>
					<!-- <div
						class="quick-info-item"
						v-if="
							!Capacitor.isNativePlatform() &&
							SubscriptionHelper.isFreeAccount()
						"> -->
					<!-- <hilltop-ad
							script-src="//chavamephu.com/b-X/V/s.dOGWl/0KYOW/cQ/Tenmk9Au/Z-U/lnkhPJTwYVyYMEzjM/y/MvTxI/tQNGjsIIzcMxzdIKxKMzwH"
							:settings="{ key: 'zone2-banner' }" /> -->
					<!-- <advertise-product-here />
					</div> -->
					<div class="quick-info-item">
						<recent-meals />
					</div>
				</div>
			</template>
			<template v-else-if="page === 2">
				<div class="row align-items-center justify-content-center">
					<div class="col-md-6 col-sm-12 mb-4">
						<weight-tracker />
					</div>
					<div class="col-md-6 col-sm-12 mb-4">
						<blood-sugar-tracker />
					</div>
					<!-- <div
						class="col-md-6 col-sm-12 mb-4"
						v-if="
							!Capacitor.isNativePlatform() &&
							SubscriptionHelper.isFreeAccount()
						"> -->
					<!-- <hilltop-ad
							script-src="//chavamephu.com/b/XQVJs/d.G/l/0dYSWZcg/veXm/9gudZ/UUlokZPvTKYJymMBzdMdyHMSjXIQtpNWjSI/zLMDzIIxyKMRw-"
							:settings="{ key: 'zone3-banner' }" /> -->
					<!-- <advertise-product-here v-if="!Capacitor.isNativePlatform()" /> -->
					<!-- <amazon-ad />
					</div> -->
				</div>
			</template>
			<template v-else-if="page === 3">
				<div class="row align-items-center justify-content-center">
					<div class="col-12 mb-4">
						<custom-report />
					</div>
					<div class="col-md-6 col-sm-12 mb-4">
						<macronutrient-report />
					</div>
					<!-- <div
						class="col-md-6 col-sm-12 mb-4"
						v-if="
							!Capacitor.isNativePlatform() &&
							SubscriptionHelper.isFreeAccount()
						"> -->
					<!-- <advertise-product-here v-if="!Capacitor.isNativePlatform()" /> -->
					<!-- <amazon-ad />
					</div> -->
					<div class="col-md-6 col-sm-12 mb-4">
						<monthly-nutrition-report />
					</div>
					<div class="col-md-6 col-sm-12 mb-4">
						<monthly-caloric-intake-report />
					</div>
					<!-- <div
						class="col-md-6 col-sm-12 mb-4"
						v-if="
							!Capacitor.isNativePlatform() &&
							SubscriptionHelper.isFreeAccount()
						"> -->
					<!-- <advertise-product-here v-if="!Capacitor.isNativePlatform()" /> -->
					<!-- <amazon-ad />
					</div> -->
					<div class="col-md-6 col-sm-12 mb-4">
						<meal-type-rating-report />
					</div>
					<div class="col-md-6 col-sm-12 mb-4">
						<meal-calendar />
					</div>
					<div class="col-md-6 col-sm-12 mb-4">
						<monthly-restaurant-report />
					</div>
					<!-- <div
						class="col-md-6 col-sm-12 mb-4"
						v-if="
							!Capacitor.isNativePlatform() &&
							SubscriptionHelper.isFreeAccount()
						">
						<advertise-product-here />
					</div> -->
				</div>
			</template>
			<template v-else-if="page === 4">
				<div class="row align-items-center justify-content-center">
					<div class="col-md-6 col-sm-12 mb-4">
						<trivia />
					</div>
					<div class="col-md-6 col-sm-12 mb-4">
						<podcast-downloads />
					</div>
					<!-- <div class="col-md-6 col-sm-12 mb-4">
						<interactive-story />
					</div> -->
				</div>
			</template>
		</div>
		<!-- <chatbot /> -->
		<!-- <AchNotification /> -->
	</div>
</template>

<script setup>
	import { ref, onBeforeMount } from "vue"
	import RecentMeals from "@/components/RecentMeals.vue"
	// import NutritionalSummary from "@/components/NutritionalSummary.vue"
	import MealCalendar from "@/components/MealCalendar.vue"
	import MonthlyNutritionReport from "@/components/MonthlyNutritionReport.vue"
	import MonthlyCaloricIntakeReport from "@/components/MonthlyCaloricIntakeReport.vue"
	import MacronutrientReport from "@/components/MacronutrientReport.vue"
	import MonthlyRestaurantReport from "@/components/MonthlyRestaurantReport.vue"
	import DailyMealPlan from "@/components/DailyMealPlan.vue"
	import WeightTracker from "@/components/WeightTracker.vue"
	import BloodSugarTracker from "@/components/BloodSugarTracker.vue"
	// import InteractiveStory from "@/components/InteractiveStory.vue"
	import Trivia from "@/components/Trivia.vue"
	// import Chatbot from "@/components/Chatbot.vue"
	// import Achievements from "@/components/Achievements.vue"
	// import AchNotification from "@/components/AchNotification.vue"
	import Birthday from "@/components/Birthday.vue"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	// import { useTokenStore } from "@/stores/token"
	import { useItemQueueStore } from "@/stores/item-queue"
	import Processing from "@/components/Processing.vue"
	import MealTypeRatingReport from "@/components/MealTypeRatingReport.vue"
	import { useUserStore } from "@/stores/user"
	// import { isOnline } from "@/utils/networkBus"
	import TodaysFoods from "@/components/TodaysFoods.vue"
	import NutritionalBanner from "@/components/NutritionalBanner.vue"
	// import HilltopAd from "@/components/HilltopAd.vue"
	// import AdsterraAd from "@/components/AdsterraAd.vue"
	import { Capacitor } from "@capacitor/core"
	import AdvertiseProductHere from "@/components/AdvertiseProductHere.vue"
	import AmazonAd from "@/components/AmazonAd.vue"
	import * as SubscriptionHelper from "@/utils/subscriptionHelper"
	import CustomReport from "@/components/CustomReport.vue"
	import PodcastDownloads from "@/components/PodcastDownloads.vue"
	import GlassCard from "@/components/GlassCard.vue"

	const userStore = useUserStore()
	// const tokenStore = useTokenStore()
	const iqStore = useItemQueueStore()
	// const user = ref({})
	const page = ref(1)

	// iqStore.load()
	// const iqStore = ref({
	// 	item_queue: [
	// 		{ file_url: null, id: "0" },
	// 		// { file_url: null, id: "0" },
	// 		// { file_url: null, id: "0" },
	// 	],
	// })

	// const fetchProfile = async () => {
	// 	try {
	// 		const response = await fetch("/api/user", {
	// 			method: "GET",
	// 			headers: {
	// 				"Content-Type": "application/json",
	// 				Authorization: `Bearer ${tokenStore.token}`,
	// 			},
	// 		})

	// 		if (hasTokenIssue(response)) {
	// 			handleTokenIssue(response)
	// 		} else {
	// 			const data = await response.json()
	// 			user.value = data
	// 		}
	// 	} catch (e) {
	// 		console.log(e)
	// 	}
	// }

	// fetchProfile()

	onBeforeMount(async () => {
		await iqStore.load()
	})
</script>

<style lang="less" scoped>
	.btn-orange {
		background-color: #ff6400;
		color: white;
		font-size: 36px;

		&:hover {
			background-color: #ff6400;
			color: white;
		}
	}

	.nav-link {
		color: #ff6400;
		font-size: 24px;
		font-weight: bolder;
	}

	.processing-section {
		background-color: #242424;
	}

	.quick-info-container {
		max-width: 800px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.quick-info-item {
		margin-bottom: 1.5rem;
		width: 100%;
	}

	/* Button style */

	.bprimary {
		// width: 25%;
		max-width: 300px;
		width: 100%;
		height: 60px;
		border-radius: 14px;
		padding: 12px 16px;
		font-weight: 700;
		font-size: 24px;
		/* Glass style tinted with current green brand color */
		// background: linear-gradient(180deg, rgb(52, 211, 153), rgb(34, 197, 94));
		background: linear-gradient(
			180deg,
			rgba(52, 211, 153, 0.16),
			rgba(34, 197, 94, 0.16)
		);
		border: 1px solid rgba(52, 211, 153, 0.35);
		color: #eafff5;
		cursor: pointer;
		box-shadow: 0 10px 24px rgba(34, 197, 94, 0.2),
			inset 0 1px 0 rgba(255, 255, 255, 0.5);
		transition: transform 0.06s ease, box-shadow 0.2s ease, filter 0.2s ease,
			background-color 0.2s ease;

		backdrop-filter: blur(16px) saturate(140%);
		-webkit-backdrop-filter: blur(16px) saturate(140%);
	}
	.bprimary:hover {
		transform: translateY(-1px);
		filter: brightness(1.06);
		box-shadow: 0 12px 28px rgba(34, 197, 94, 0.28),
			inset 0 1px 0 rgba(255, 255, 255, 0.55);
	}
	.bprimary:active {
		transform: translateY(0);
		box-shadow: 0 6px 16px rgba(34, 197, 94, 0.24);
	}
</style>
